// import { Filtros } from '../receber/filtros';
import { Component/*, OnInit*/ } from '@angular/core';
// import { LancamentoPesquisa } from '@app/pages/financeiro/lancamento/lancamento.model';
// import { IdDescricao } from '@app/models/Util/id-descricao';
// import { RelatorioService } from '@app/services/relatorio.service';
// import { ConsultasService } from '@app/services/consultas.service';
// import { CDSMask } from '@app/utils/CDSMask';

// import debounce from '@app/utils/debounce';

@Component({
  selector: 'app-faturamento',
  templateUrl: './faturamento.component.html',
  styleUrls: ['./faturamento.component.scss']
})
export class FaturamentoComponent /*implements OnInit*/ {

  // constructor(
  //   private relatorioService: RelatorioService,
  //   private consultasService: ConsultasService) { }

  // cdsMask: CDSMask = new CDSMask();
  // filtros: Filtros = new Filtros();
  // pesquisa: LancamentoPesquisa = new LancamentoPesquisa();

  // lstParticipante: Array<any> = [{}];
  // lstUnidades: IdDescricao[];
  // lstConta: IdDescricao[] = [];
  // receber = false;
  // recebidos = false;

  // rel: any;

  // totalReceber = 0;
  // totalRecebidas = 0;
  // pesquisando: boolean;

  // _debounce: any;
  // _pesquisa: any;

  // ngOnInit() {
  //   this.pesquisa.ContaId = 0;
  //   this.filtros.ProcessoId = null;
  //   this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
  //   this.consultasService.consultar('CONTA').toPromise().then(data => this.lstConta = data);
  // }

  // pesquisar() {
  //   this.pesquisando = true;
  //   this.relatorioService.recebidas(this.filtros)
  //     .toPromise().then((data) => {
  //       this.rel = data;
  //       this.somaSaldo();
  //       this.pesquisando = false;
  //     },
  //       () => this.pesquisando = false);
  // }

  // pesquisar2() {
  //   this.pesquisando = true;
  //   this.relatorioService.receber(this.filtros)
  //     .toPromise().then((data) => {
  //       this.rel = data;
  //       this.somaSaldo();
  //       this.pesquisando = false;
  //     },
  //       () => this.pesquisando = false);
  // }

  // receberOn() {
  //   this.receber = true;
  //   this.recebidos = false;
  // }

  // recebidosOn() {
  //   this.recebidos = true;
  //   this.receber = false;
  // }

  // public somaSaldo(): void {
  //   this.totalRecebidas = 0;
  //   this.rel.forEach(element => { this.totalRecebidas += element.ValorRecebido; });
  //   this.totalReceber = 0;
  //   this.rel.forEach(element => { this.totalReceber += element.Valor; });
  // }

  // public ngxselect_typed(value: any): void {
  //   this.lstParticipante = [{ id: -1, text: 'Pesquisando...' + value, disabled: true }];
  //   this._pesquisa = value;
  //   if (!this._debounce) {
  //     this._debounce = debounce(() => {
  //       this.consultasService.consultar('PARTICIPANTE', this._pesquisa).toPromise().then(data => {
  //         this.lstParticipante = data;
  //       });
  //     }, 500);
  //   }
  //   this._debounce();
  // }

}
